import { usePage } from '@/hooks'
import React from 'react'
import HtmlContent from '../HtmlContent'
import style from './styles/contest.module.scss'

interface IProps {
  id: number
  image: string
  title: string
  theme: string
  date: string
}

const ContestCard = ({
  id,
  image,
  title,
  theme,
  date
}: IProps): React.ReactElement => {
  const page = usePage()
  const { contest_detail: contestDetail } = page?.init_state?.global?.config
  const url = `${contestDetail}?element_id=${id}`

  return (
    <a href={url} className={style.contest__link}>
      <img
        src={image}
        alt={title}
        width='320px'
        height='200px'
        className={style.contest__image}
      />
      <div className={style.contest_right}>
        <div>
          <span className={style.contest__title}>{title}</span>
          <div className={style.contest__theme}>
            Тема:&nbsp;
            <HtmlContent content={theme} className={style.contest__text} />
          </div>
        </div>
        <span className={style.contest__date}>{date}</span>
      </div>
    </a>
  )
}

export default ContestCard
